import { useEffect } from 'react';

export default function useTitle(suffix = '', includeTitle = true) {
    const baseTitle = process.env.REACT_APP_URL || 'Site';

    useEffect(() => {
        if (includeTitle) {
            document.title = suffix ? `${suffix} | ${baseTitle}` : baseTitle;
        } else {
            document.title = suffix;
        }
    }, [suffix, baseTitle]);
}